import { render } from "./HeightTransition.vue?vue&type=template&id=fdf44132"
import script from "./HeightTransition.vue?vue&type=script&lang=js"
export * from "./HeightTransition.vue?vue&type=script&lang=js"

import "./HeightTransition.vue?vue&type=style&index=0&id=fdf44132&lang=css"

import exportComponent from "C:\\Server-Testumgebung\\way-academy-app-main\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__